export default "__VITE_ASSET__Bsir_Hve__"